import { Flex } from '@modusign/design-system';

import SegmentedControlButton from './SegmentedControlButton';

interface SegmentedControlProps {
  tabs: [string, string];
  activeIndex: 0 | 1;
  onChange: (index: 0 | 1) => void;
}

export default function SegmentedControl({ activeIndex, onChange, tabs }: SegmentedControlProps) {
  return (
    <Flex
      bg="buttonBackgroundNeutralSlightlyDark"
      border="1px solid"
      borderColor="buttonBackgroundNeutralSlightlyDark"
      borderRadius="8px"
      gap="3px"
      p="3px"
    >
      <SegmentedControlButton active={activeIndex === 0} onClick={() => onChange(0)}>
        {tabs[0]}
      </SegmentedControlButton>
      <SegmentedControlButton active={activeIndex === 1} onClick={() => onChange(1)}>
        {tabs[1]}
      </SegmentedControlButton>
    </Flex>
  );
}
